import React from "react";
import ChatPage from "../../components/Chat/ChatPage";
import TherapistSideBar from "../../common/TherapistSidebar/TherapistSidebar";

const TherapistMessagesPage = () => (
  <ChatPage role="therapist" SidebarComponent={TherapistSideBar} />
);

export default TherapistMessagesPage;
